import React, { useState, useEffect } from "react";
import { legalAPI } from "../services/api";
import { ShimmerTermsContent } from "../components/Shimmer";
import "../css/TermsPolicies.css";

const TermsPolicies = () => {
  const [activeTab, setActiveTab] = useState("terms");
  const [termsContent, setTermsContent] = useState("");
  const [privacyContent, setPrivacyContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch legal documents on mount
  useEffect(() => {
    const fetchLegalDocuments = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch both documents in parallel
        const [termsResponse, privacyResponse] = await Promise.all([
          legalAPI.getTermsAndConditions(),
          legalAPI.getPrivacyPolicy()
        ]);

        if (termsResponse.data?.Status === 'Success') {
          setTermsContent(termsResponse.data.Document?.Content || '');
        }

        if (privacyResponse.data?.Status === 'Success') {
          setPrivacyContent(privacyResponse.data.Document?.Content || '');
        }
      } catch (err) {
        setError('Failed to load content. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchLegalDocuments();
  }, []);

  return (
    <div className="terms-policies-page">
      <div className="container-fluid px-4 py-4">
        {/* Tabs */}
        <div className="terms-tabs">
          <button
            className={`terms-tab ${activeTab === "terms" ? "active" : ""}`}
            onClick={() => setActiveTab("terms")}
          >
            Terms & Conditions
          </button>
          <button
            className={`terms-tab ${activeTab === "privacy" ? "active" : ""}`}
            onClick={() => setActiveTab("privacy")}
          >
            Privacy Policy
          </button>
        </div>

        {/* Content Card */}
        <div className="terms-content-card">
          {loading ? (
            <ShimmerTermsContent />
          ) : error ? (
            <div className="terms-error">
              <p>{error}</p>
            </div>
          ) : (
            <div
              className="terms-html-content"
              dangerouslySetInnerHTML={{
                __html: activeTab === "terms" ? termsContent : privacyContent
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TermsPolicies;
